<template>
  <v-container id="riepilogo_ordine">
    <v-card
      color="#efefef"
      class="ma-0 mb-5 pa-6"
    >
      <v-row>
        <!-- {{ cliente }} -->
        <v-col>
          <v-simple-table
            class="bordered-table dense"
            width="100%"
          >
            <thead>
              <tr>
                <th>Cod. Cli.</th>
                <th>Cliente</th>
                <th class="text-no-wrap text-center">
                  Linea
                </th>
                <th class="text-no-wrap text-center">
                  Data Ordine
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="text-h2">
                  {{ order.codice }}
                </td>
                <td class="text-no-wrap pr-3">
                  {{ cliente.ragsoc }} {{ cliente.indiri_1 }}<br>
                  {{ cliente.indiri2 }} {{ cliente.locali }}
                </td>
                <td class="text-h2 text-center">
                  {{ $linea().label }}
                </td>
                <td class="text-h2 text-center">
                  {{ order.dataordine }}
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-col>
      </v-row>

      <section
        class="STEP1"
        @dblclick="$emit('nextStep',1)"
      >
        <v-card
          width="100%"
          class="my-2 "
        >
          <v-col class="pa-6">
            <v-row>
              <v-btn
                dark
                icon
              >
                <v-icon
                  color="primary"
                  @click="$emit('nextStep',1)"
                >
                  mdi-circle-edit-outline
                </v-icon>
              </v-btn>
              <v-col cols="auto ">
                Riferimento Occhiale (n.Busta o Nome)<br>
                <span class="text-h2">{{ order.desrif }}</span>
              </v-col>
              <v-col v-if="order.monsmo=='M'">
                <template v-if="order.lens?.lendor=='CC'">
                  <v-col class="text-right">
                    Lenti da me ordinate a <b>{{ order.lens.altra_ditta_lenti }}</b> cod. ditta lenti: {{ order.lens.identi }}<br>
                    in data: <b>{{ new Date(order.lens.dataord_lenti).toLocaleDateString('it-IT') }}</b>
                  </v-col>
                </template>
                <template v-else-if="order.lens?.lendor=='CD'">
                  <v-col class="text-right">
                    Lenti da ordinare per nostro conto a <b>{{ order.lens.altra_ditta_lenti }}</b><br>
                    Ns. Cod. Ditta Lenti: <b>{{ order.lens.identi }}</b>
                  </v-col>
                </template>
                <template v-else-if="order.lens?.grvlens?.dx || order.lens?.grvlens?.sx">
                  <v-col class="text-right">
                    Ditta Lenti: <b> HERZACH </b>
                  </v-col>
                </template>
                <template v-else>
                  <v-col class="text-right" />
                </template>
              </v-col>
            </v-row>
          </v-col>
        </v-card>
      </section>
      <section
        class="STEP2"
        @dblclick="$emit('nextStep',2)"
      >
        <template
          v-if="order.monsmo=='M' && (order.lens?.lendor=='CC' || order.lens?.lendor=='CD' || (order.lens?.grvlens?.dx || order.lens?.grvlens?.sx))"
          class="caratteristica_lenti"
        >
          <v-row>
            <v-col>
              <v-simple-table
                class="bordered-table dense"
                width="100%"
              >
                <thead>
                  <tr>
                    <th>Lente</th>
                    <th>Tiplogia </th>
                    <th>Trattamento </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td
                      class="text-h3"
                      width="100px"
                    >
                      OD
                    </td>
                    <td class="text-no-wrap">
                      {{ order.lens.d_destip }}
                    </td>
                    <td class="text-no-wrap">
                      {{ order.lens.d_destrt }}
                    </td>
                  </tr>
                  <tr>
                    <td
                      class="text-h3"
                      width="100px"
                    >
                      OS
                    </td>
                    <td class="text-no-wrap">
                      {{ order.lens.s_destip }}
                    </td>
                    <td class="text-no-wrap">
                      {{ order.lens.s_destrt }}
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
          </v-row>

          <v-row>
            <!-- {{ caratteristiche  lenti }} -->
            <v-col>
              <v-simple-table
                class="bordered-table dense"
                width="100%"
              >
                <thead>
                  <tr>
                    <th>Lente</th>
                    <th>SF</th>
                    <th>CYL</th>
                    <th class="text-center">
                      AX
                    </th>
                    <th>ADD</th>
                    <th>SD</th>
                    <th>ALT</th>
                    <th>PRISMA</th>
                    <th>GRADI</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="order.lens.d_filtro">
                    <td class="text-h3">
                      OD
                    </td>
                    <td class="font-weight-bold">
                      FILTRO per lente DX
                    </td>
                  </tr>
                  <tr v-else>
                    <td class="text-h3">
                      OD
                    </td>
                    <td class="text-no-wrap ">
                      {{ order.lens.d_vsfero }}
                    </td>
                    <td class="text-no-wrap">
                      {{ order.lens.d_cilind }}
                    </td>
                    <td class="text-no-wrap text-center">
                      {{ order.lens.d_vlasse }}
                    </td>
                    <td class="text-no-wrap">
                      {{ order.lens.d_addizi }}
                    </td>
                    <td class="text-no-wrap">
                      {{ order.lens.d_semidi }}
                    </td>
                    <td class="text-no-wrap">
                      {{ order.lens.d_altezz }}
                    </td>

                    <td class="text-no-wrap">
                      {{ order.lens.d_prisma }}
                    </td>
                    <td class="text-no-wrap">
                      {{ order.lens.d_vgradi }}
                    </td>
                  </tr>

                  <tr v-if="order.lens.s_filtro">
                    <td class="text-h3">
                      OS
                    </td>
                    <td class="font-weight-bold">
                      FILTRO per lente SX
                    </td>
                  </tr>
                  <tr v-else>
                    <td class="text-h3">
                      OS
                    </td>
                    <td class="text-no-wrap">
                      {{ order.lens.s_vsfero }}
                    </td>
                    <td class="text-no-wrap">
                      {{ order.lens.s_cilind }}
                    </td>
                    <td class="text-no-wrap text-center">
                      {{ order.lens.s_vlasse }} &nbsp;&nbsp;
                      {{ order.lens.tabint }}
                    </td>
                    <td class="text-no-wrap">
                      {{ order.lens.s_addizi }}
                    </td>
                    <td class="text-no-wrap">
                      {{ order.lens.s_semidi }}
                    </td>
                    <td class="text-no-wrap">
                      {{ order.lens.s_altezz }}
                    </td>
                    <td class="text-no-wrap">
                      {{ order.lens.s_prisma }}
                    </td>
                    <td class="text-no-wrap">
                      {{ order.lens.s_vgradi }}
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
          </v-row>
        </template>
        <v-row
          v-if="order.lens?.fornitura_lente?.value"
          class="ma-4 text-h3 text-no-wrap"
        >
          Fornire lenti: {{ order.lens?.fornitura_lente.title }}  <b v-if="order.lens?.fornitura_lente.value=='diametro'">&nbsp;Diametro: {{ order.lens?.diamet }}</b>
        </v-row>
      </section>
      <v-row>
        <!-- {{ componenti  }} -->
        <v-col>
          <v-simple-table
            class="bordered-table dense"
            width="100%"
          >
            <thead>
              <tr>
                <th
                  class="text-no-wrap text-center"
                  @dblclick="$emit('nextStep',2)"
                >
                  Modello
                </th>
                <th
                  class="text-no-wrap text-center"
                  @dblclick="$emit('nextStep',2)"
                >
                  Calibro
                </th>
                <th
                  class="text-no-wrap text-center"
                  @dblclick="$emit('nextStep',3)"
                >
                  Ponte
                </th>
                <th
                  class="text-no-wrap text-center"
                  @dblclick="$emit('nextStep',3)"
                >
                  Nasello
                </th>
                <th
                  class="text-no-wrap text-center"
                  @dblclick="$emit('nextStep',3)"
                >
                  Aste
                </th>
                <th
                  class="text-no-wrap text-center"
                  @dblclick="$emit('nextStep',3)"
                >
                  Terminale
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td
                  width="120"
                  class="text-h2 text-center "
                  @dblclick="$emit('nextStep',2)"
                >
                  <v-img
                    :src="`./img/FRM/${order?.lens?.desmod ?? ''}.png`"
                    :lazy-src="'./img/noimage.jpg'"
                    width="120"
                    contain
                    eager
                  >
                    {{ order.monsmo=='M'?order.lens.desmod : '--' }}
                  </v-img>
                </td>
                <td
                  class="text-no-wrap text-h3 text-center"
                  @dblclick="$emit('nextStep',2)"
                >
                  {{ order.monsmo=='M'?order.lens.calibr:'' }}
                </td>
                <td
                  class="text-no-wrap text-center"
                  @dblclick="$emit('nextStep',3)"
                >
                  [{{ order.tippon.tipcompo }}] {{ order.tippon.descompo }}
                  <v-img
                    :src="`./img/PONTE/${$linea().label}_${order.tippon.tipcompo}.png`"
                    width="70"
                    class="mx-auto"
                    contain
                  />
                </td>
                <td
                  class="text-no-wrap text-center"
                  @dblclick="$emit('nextStep',3)"
                >
                  {{ order.nasell.descompo }}<br>
                  {{ order.alette==1?'** Aletta Piccola':'' }}{{ order.alette==2?'** Aletta Gande':'' }}
                  <v-img
                    :src="`./img/NAS/${order.nasell.tipcompo}.png`"
                    width="40"
                    class="mx-auto"
                    contain
                  />
                </td>
                <td
                  class="text-no-wrap text-center"
                  @dblclick="$emit('nextStep',3)"
                >
                  [{{ order.vlaste.tipcompo }}] {{ order.vlaste.descompo }}
                  <v-img
                    :src="`./img/ASTE/${$linea().label}_${order.vlaste.tipcompo}.png`"
                    width="90"
                    class="mx-auto"
                    contain
                  />
                </td>
                <td
                  class="text-no-wrap text-center"
                  @dblclick="$emit('nextStep',3)"
                >
                  [{{ order.vlterm.tipcompo }}] {{ order.vlterm.descompo }}<br>
                  <v-img
                    :src="`./img/TERM/${$linea().label}_${order.vlterm.tipcompo}.png`"
                    :lazy-src="'./img/noimage.jpg'"
                    width="50"
                    class="mx-auto"
                    contain
                  />
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-col>
      </v-row>

      <!-- {{ Colori  }} -->
      <section
        class="STEP4"
        @dblclick="$emit('nextStep',4)"
      >
        <v-row>
          <v-col>
            <v-simple-table
              class="refColors bordered-table dense"
              width="100%"
            >
              <thead>
                <tr>
                  <th
                    style="height:20px"
                    class="text-center"
                    colspan="2"
                  >
                    Asta
                  </th>
                  <th
                    style="height:20px"
                    class="text-center"
                    colspan="2"
                  >
                    Tallone
                  </th>
                  <th
                    style="height:20px"
                    class="text-center"
                  >
                    Ponte
                  </th>
                  <th
                    style="height:20px"
                    class="text-center"
                    colspan="2"
                  >
                    Perno Ponte
                  </th>
                  <th
                    style="height:20px"
                    class="text-center"
                    colspan="2"
                  >
                    Perno Tallone
                  </th>
                </tr>
                <tr>
                  <th
                    style="height:20px"
                    class="text-center"
                  >
                    DX
                  </th>
                  <th
                    style="height:20px"
                    class="text-center"
                  >
                    SX
                  </th>
                  <th
                    style="height:20px"
                    class="text-center"
                  >
                    DX
                  </th>
                  <th
                    style="height:20px"
                    class="text-center"
                  >
                    SX
                  </th>
                  <th
                    style="height:20px"
                    class="text-center"
                  >
                    --
                  </th>
                  <th
                    style="height:20px"
                    class="text-center"
                  >
                    DX
                  </th>
                  <th
                    style="height:20px"
                    class="text-center"
                  >
                    SX
                  </th>
                  <th
                    style="height:20px"
                    class="text-center"
                  >
                    DX
                  </th>
                  <th
                    style="height:20px"
                    class="text-center"
                  >
                    SX
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr class="text-center ">
                  <td class="">
                    {{ order.col_astadx.numcol }} {{ order.col_astadx.codcol }}

                    <v-img
                      :src="`./img/COL/${$linea().label}_${ order.col_astadx.numcol}.png`"
                      height="20"
                      aspect-ratio="1"
                      contain
                    />
                  </td>
                  <td class="text-no-wrap">
                    {{ order.col_astasx.numcol }} {{ order.col_astasx.codcol }}
                    <v-img
                      :src="`./img/COL/${$linea().label}_${ order.col_astasx.numcol}.png`"
                      height="20"
                      aspect-ratio="1"
                      contain
                    />
                  </td>
                  <td class="text-no-wrap">
                    {{ order.col_talldx.numcol }} {{ order.col_talldx.codcol }}
                    <v-img
                      :src="`./img/COL/${$linea().label}_${ order.col_talldx.numcol}.png`"
                      height="20"
                      aspect-ratio="1"
                      contain
                    />
                  </td>
                  <td class="text-no-wrap">
                    {{ order.col_tallsx.numcol }} {{ order.col_tallsx.codcol }}
                    <v-img
                      :src="`./img/COL/${$linea().label}_${ order.col_tallsx.numcol}.png`"
                      height="20"
                      aspect-ratio="1"
                      contain
                    />
                  </td>
                  <td class="text-no-wrap">
                    {{ order.col_ponte.numcol }} {{ order.col_ponte.codcol }}
                    <v-img
                      :src="`./img/COL/${$linea().label}_${ order.col_ponte.numcol}.png`"
                      height="20"
                      aspect-ratio="1"
                      contain
                    />
                  </td>
                  <td class="">
                    {{ order.col_perno_ponte_dx.numcol }} {{ order.col_perno_ponte_dx.codcol }}
                    <v-img
                      :src="`./img/COL/${$linea().label}_${ order.col_perno_ponte_dx.numcol}.png`"
                      height="20"
                      aspect-ratio="1"
                      contain
                    />
                  </td>
                  <td class="text-no-wrap">
                    {{ order.col_perno_ponte_sx.numcol }} {{ order.col_perno_ponte_sx.codcol }}
                    <v-img
                      :src="`./img/COL/${$linea().label}_${ order.col_perno_ponte_sx.numcol}.png`"
                      height="20"
                      aspect-ratio="1"
                      contain
                    />
                  </td>
                  <td class="text-no-wrap">
                    {{ order.col_perno_tall_dx.numcol }} {{ order.col_perno_tall_dx.codcol }}
                    <v-img
                      :src="`./img/COL/${$linea().label}_${ order.col_perno_tall_dx.numcol}.png`"
                      height="20"
                      aspect-ratio="1"
                      contain
                    />
                  </td>
                  <td class="text-no-wrap">
                    {{ order.col_perno_tall_sx.numcol }} {{ order.col_perno_tall_sx.codcol }}
                    <v-img
                      :src="`./img/COL/${$linea().label}_${ order.col_perno_tall_sx.numcol}.png`"
                      height="20"
                      aspect-ratio="1"
                      contain
                    />
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
        </v-row>
      </section>
      <!-- {{ CLP  }} -->
      <section
        v-if="order.clipon=='CLP'"
        class="STEP5 my-4"
        @dblclick="$emit('nextStep',5)"
      >
        <v-row justify="center">
          <span class="text-h2 font-weight-light">CLIP-ON ABBINATO</span>
        </v-row>
        <v-row>
          <v-col>
            <v-simple-table
              class="refColors bordered-table dense"
              width="100%"
            >
              <thead>
                <tr>
                  <th
                    style="height:20px"
                    class="text-center"
                  />

                  <th
                    style="height:20px"
                    class="text-center"
                  />
                  <th
                    style="height:20px"
                    class="text-center"
                    colspan="2"
                  >
                    Perno Ponte
                  </th>
                </tr>
                <tr>
                  <th
                    style="height:20px"
                    class="text-center"
                  >
                    Filtro
                  </th>
                  <th
                    style="height:20px"
                    class="text-center"
                  >
                    Ponte
                  </th>
                  <th
                    style="height:20px"
                    class="text-center"
                  >
                    DX
                  </th>
                  <th
                    style="height:20px"
                    class="text-center"
                  >
                    SX
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr class="text-center ">
                  <td class="text-no-wrap">
                    {{ order.filtro_colore.codcol }} {{ order.filtro_colore.coldesc }}
                    <v-img
                      :src="`./img/FLT/CLP_0${ order.filtro_colore.tipcompo}.png`"
                      height="20"
                      aspect-ratio="1"
                      contain
                    />
                  </td>

                  <td class="text-no-wrap">
                    {{ order.colclp_ponte.numcol }} {{ order.colclp_ponte.codcol }}
                    <v-img
                      :src="`./img/COL/CLP_${ order.colclp_ponte.numcol}.png`"
                      height="20"
                      aspect-ratio="1"
                      contain
                    />
                  </td>
                  <td class="">
                    {{ order.colclp_perpon_dx.numcol }} {{ order.colclp_perpon_dx.codcol }}
                    <v-img
                      :src="`./img/COL/CLP_${ order.colclp_perpon_dx.numcol}.png`"
                      height="20"
                      aspect-ratio="1"
                      contain
                    />
                  </td>
                  <td class="text-no-wrap">
                    {{ order.colclp_perpon_sx.numcol }} {{ order.colclp_perpon_sx.codcol }}
                    <v-img
                      :src="`./img/COL/CLP_${ order.colclp_perpon_sx.numcol}.png`"
                      height="20"
                      aspect-ratio="1"
                      contain
                    />
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
        </v-row>
      </section>
      <!-- NOTE lavorazione -->
      <v-sheet class="mt-1">
        <v-row>
          <v-col
            cols="12"
            class="mx-2"
          >
            <p>Note lavorazione:</p>
            <ul>
              <li>{{ (order.monsmo=='M' )?'Montaggio: SI':'Montaggio: NO' }}</li>
              <li v-if="[7,8].includes(+order.vlterm.tipcompo)">
                {{ `Fascia Elastica: ${order.fascia}` }}
              </li>
              <li v-if="order.carnet && Object.keys(order.carnet).length>0">
                Utilizzo <b>CARNET {{ order.carnet.CNEF_NUMERO }} </b> buono nr. <b>{{ order.carnet.NEXT_ORBF_BUONO }}</b>
              </li>
              <li
                v-if="order.lens?.fornitura_lente?.value"
              >
                {{ order.lens?.fornitura_lente.title }}  <b v-if="order.lens?.fornitura_lente.value=='diametro'">&nbsp;Diametro: {{ order.lens?.diamet }}</b>
              </li>
              <li v-if="order.lens?.desmod=='NN'">
                Lente non in elenco: <b>{{ order.lens?.nolens_detail }}</b>
              </li>
              <li v-if="(order.lens?.grvlens?.dx || order.lens?.grvlens?.sx)">
                Lente DX: <b>{{ order.lens?.grvlens?.dx.itemcode }}</b> {{ order.lens?.grvlens?.dx.itemname }}
                <br>
                Lente SX: <b>{{ order.lens?.grvlens?.sx.itemcode }}</b> {{ order.lens?.grvlens?.sx.itemname }}
              </li>
            </ul>
          </v-col>
          <v-col
            cols="12"
          >
            <v-textarea
              v-model="steporder.noteord"
              counter
              class="mx-4"
              outlined
              label="Note Aggiuntive"
              auto-grow
            />
          </v-col>
        </v-row>
      </v-sheet>
    </v-card>
    <v-btn
      color="primary"
      @click="getPdf"
    >
      PDF
    </v-btn>
    <v-btn
      color="primary"
      @click="stdOrder"
    >
      Send
    </v-btn>
    <v-btn
      text
      @click="order.clipon === 'CLP'? $emit('prevStep', step):$emit('prevStep', step - 1)"
    >
      Indietro
    </v-btn>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'
  import engine from '@/plugins/engine'
  // import { Printd } from 'printd'
  // import { get } from 'core-js/core/dict';

  export default {
    name: 'Riepilogo',
    props: {
      step: {
        type: Number,
        default: null,
      },
    },
    data () {
      return {
        steporder: {},
        validForm: true,
        loading: false,
      }
    },
    computed: {
      ...mapState(['auth', 'order', 'carnet', 'clidata']),
      isMobile: function () {
        return this.$vuetify.breakpoint.xsOnly
      },
      rules () {
        return {
          required: value => !!value || 'Required.',
          min: v => (v && v.length >= 4) || 'Min 4 characters',
        }
      },

      cliente () {
        return this.clidata.anacli
      },
    },
    watch: {

    },
    mounted () {
      this.steporder = Object.assign({}, this.order)
      this.steporder.step = this.step
      this.steporder.dataordine = new Date().toLocaleDateString('it-IT')
      this.steporder.carnet = this.carnet
      this.$store.commit('setOrder', this.steporder)
      console.error('Ricontrollare validità CarNum -- ma non ricordo cosa e perchè. 30.01.26 Dino')
    },
    destroyed () {

    },
    methods: {
      getPdf () {
        this.$store.commit('setOrder', this.steporder)
        console.log('order', this.order)
        this.loading = true
        engine.getPdf(this.steporder)
          .then(result => {
            if (result) {
              // (C2) TO "FORCE DOWNLOAD"
              var url = window.URL.createObjectURL(result)
              var anchor = document.createElement('a')
              anchor.href = url
              anchor.target = '_blank'
              // anchor.download = obj.filename || `${this.page}.pdf`
              anchor.click()
              // // (C3) CLEAN UP
              // window.URL.revokeObjectURL(url)
              // document.removeChild(anchor)
            }
            if (result.error) {
              this.$store.commit('setSnack', { message: result.error_reason, color: '#c54747d4' })
            }
            // this.$store.commit('setSnack', { message: 'PDF ok', color: '#4caf50' })
          })
          .catch((errore) => {
            console.log('api err: ', errore)
          }).finally(() => { this.loading = false })
      },
      stdOrder () {
        this.$store.commit('setOrder', this.steporder)
        console.log('order_swf', this.order)
        this.$emit('stdOrder')
      },
    },
  }
</script>
<style>
#riepilogo_ordine .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background-color: transparent !important; /* remove on hover effect */
}

#riepilogo_ordine .v-data-table th{
  font-size: 1.3rem;
}
@media print {
  #riepilogo_ordine {
    transform: scale(0.9);
    transform-origin: top left;
  }
}
</style>
